<script>
    import SelectField from "../../common/select-field.vue";
    import User from "./data/User";
    import UserValidator from "./data/UserValidator";

    export default {
        name: "user-wizard-user-type-field",
        components: {SelectField},
        props: {
            user: {type: User, required: true},
            validator: {type: UserValidator, required: true},
            disabled: {type: Boolean}
        },
        computed: {
            label() {
                return Lang.langGet('User Type');
            },
            value() {
                if (this.user.isLdap) return this.user.types.find(type => type.value === 'ldap');
                if (this.user.isExternal) return this.user.types.find(type => type.value === 'external');
                return this.user.types.find(type => type.value === 'default');
            }
        },
        methods: {
            handleChange(value) {
                if (value === 'ldap') {
                    this.user.isLdap = true;
                    this.user.isExternal = false;
                    this.user.firstName = 'LDAP Role';
                    this.user.password = '%UserPasswor6%';
                    this.user.passwordConfirmation = '%UserPasswor6%';

                    this.validator.update('firstName', true);
                    this.validator.update('passwords', true);
                }
                if (value === 'external') {
                    this.user.isLdap = false;
                    this.user.isExternal = true;
                    this.user.firstName = 'External User';
                    this.user.password = '%UserPasswor6%';
                    this.user.passwordConfirmation = '%UserPasswor6%';

                    this.validator.update('firstName', true);
                    this.validator.update('passwords', true);
                    if (_.isEmpty(this.user.email)) {
                        this.validator.update('email', true);
                    }
                }
                if (value === 'default') {
                    this.user.isLdap = false;
                    this.user.isExternal = false;
                    this.user.firstName = undefined;
                    this.user.password = null;
                    this.user.passwordConfirmation = null;

                    this.validator.update('firstName', false);
                    if (_.isEmpty(this.user.email)) {
                        this.validator.update('email', false);
                    }
                }
            }
        }
    }
</script>

<template>
    <select-field
        :disabled="disabled"
        :value="value"
        @input="handleChange"
        :items="user.getUserTypes()"
        :label="label"
    />
</template>

